import { render, staticRenderFns } from "./HttpRequestCopyFromCampaign.vue?vue&type=template&id=2aff564a&scoped=true"
import script from "./HttpRequestCopyFromCampaign.vue?vue&type=script&lang=js"
export * from "./HttpRequestCopyFromCampaign.vue?vue&type=script&lang=js"
import style0 from "./HttpRequestCopyFromCampaign.vue?vue&type=style&index=0&id=2aff564a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff564a",
  null
  
)

export default component.exports